/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Internaltenant1Inputs */

const en_entity_internaltenant1 = /** @type {(inputs: Entity_Internaltenant1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internal Tenant`)
};

const de_entity_internaltenant1 = /** @type {(inputs: Entity_Internaltenant1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interner Mandant`)
};

/**
* | output |
* | --- |
* | "Internal Tenant" |
*
* @param {Entity_Internaltenant1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_internaltenant1 = /** @type {((inputs?: Entity_Internaltenant1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Internaltenant1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_internaltenant1(inputs)
	return de_entity_internaltenant1(inputs)
});
export { entity_internaltenant1 as "entity_internalTenant" }